import { StyledRemoveButtonIcon } from './LineItemView.styles';

function RemoveButtonIcon(
  props: React.ButtonHTMLAttributes<HTMLButtonElement>,
): JSX.Element {
  return (
    <StyledRemoveButtonIcon {...props}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.453491 0.453074C0.230347 0.676231 0.230347 1.03804 0.453491 1.2612L5.18774 5.99545L0.453509 10.7297C0.230347 10.9528 0.230347 11.3146 0.453509 11.5378C0.676671 11.761 1.03847 11.761 1.26163 11.5378L5.99587 6.80357L10.7301 11.5378C10.9533 11.761 11.3151 11.761 11.5382 11.5378C11.7614 11.3146 11.7614 10.9528 11.5382 10.7297L6.80399 5.99545L11.5382 1.2612C11.7614 1.03804 11.7614 0.676231 11.5382 0.453074C11.3151 0.229916 10.9533 0.229916 10.7301 0.453074L5.99587 5.18732L1.26161 0.453074C1.03847 0.229916 0.676653 0.229916 0.453491 0.453074Z"
          fill="white"
        />
      </svg>
    </StyledRemoveButtonIcon>
  );
}

export default RemoveButtonIcon;
